import { Form } from "antd";
import React from "react";
import { InputNumberStd } from "src/components/InputNumberStd";

type PropsMaxHeight = { name: string[] };

export const MaxHeight: React.FC<PropsMaxHeight> = ({ name }) => (
  <Form.Item name={name} label="Максимальная высота изображения">
    <InputNumberStd min={1} precision={0} addonAfter="px" />
  </Form.Item>
);
